import { useState } from 'react';

import { Order, OrderEnum, SortEnum } from '../types/pagination.types';

/**
 * @deprecated Use useTable.ts
 */
export const useSort = (sortby: string = SortEnum.title) => {
  const [sortBy, setSortBy] = useState<string>(sortby);
  const [order, setOrder] = useState<Order>(OrderEnum.asc);

  const sortOnClick = (header: string) => {
    const isAsc = sortBy === header && order === OrderEnum.asc;
    setOrder(isAsc ? OrderEnum.desc : OrderEnum.asc);
    setSortBy(header);
  };

  return { sortOnClick, sortBy, order };
};
